import * as I18n from 'circe/I18n';
import { NAME as APP_NAME, ROUTES as CARRIERS_ROUTES } from 'domain/carriers/constants';

export const NAME = `${APP_NAME}/CARRIERS`;

export const REDUCER_NAME = 'carriers';

export const FORM_NAME = 'CREATE_CARRIERS';

export const ROUTES = {
  ROOT: `${CARRIERS_ROUTES.ROOT}/create`,
};

export const PAGE_TITLE = I18n.str('createTransporter', 'Create Transporter');
export const SECTION_NAME = I18n.str('transporterInfo', 'Transporter Info');
export const SUCCESS_MESSAGE = I18n.str(
  'transporterCreatedSuccessfully',
  'Transporter Created Successfully',
);
